import {useKeycloak} from '@react-keycloak/web';
import {ConfigObjectType, loginContainer, StateId} from '@wallaby-ui/core';
import {KeycloakTokenParsed} from 'keycloak-js';
import * as React from 'react';
import {useCallback} from 'react';
import {connect, ConnectedProps} from 'react-redux';
import {SpringValue} from 'react-spring';
import {RootState} from 'src/js/store';
import {useAppDispatch} from 'src/js/store_hooks';

import {NavigationBox} from './NavigationBox';
import {NavigationContext, ValuesToCopy} from '../useNavigationContext';

interface OwnProps {
  logoSignName: string;
  logoName: string;
  config: ConfigObjectType;
  loginStateId: StateId;
  navigationContext: NavigationContext;
  valuesToCopy: ValuesToCopy;
}

const mapState = (state: RootState, props: OwnProps) => ({
  currentPathName: state.router.location?.pathname,
});

const connector = connect(mapState);
type PropsFromRedux = ConnectedProps<typeof connector>;

type Props = PropsFromRedux & OwnProps;

export const keycloakTokenParsed = {
  current: undefined as KeycloakTokenParsed | undefined,
};
const NavigationContainerComponent: React.FC<Props> = (props) => {
  const {currentPathName, logoSignName, logoName, config, loginStateId, navigationContext, valuesToCopy} = props;

  const {keycloak} = useKeycloak();
  const dispatch = useAppDispatch();

  const handleLogout = useCallback(() => {
    dispatch(loginContainer.actions.logout(loginStateId, config.service.url.logout, keycloak));
  }, [config, dispatch, keycloak, loginStateId]);

  keycloakTokenParsed.current = keycloak.tokenParsed;
  return (
    <NavigationBox
      navigationContext={navigationContext}
      valuesToCopy={valuesToCopy}
      currentPathName={currentPathName}
      logoName={logoName}
      logoSignName={logoSignName}
      isLoggedIn={keycloak && keycloak.authenticated}
      handleLogout={handleLogout}
      user={keycloakTokenParsed.current?.preferred_username ?? ''}
      config={config}
    />
  );
};

NavigationContainerComponent.displayName = 'NavigationContainer';

export const NavigationContainer = connector(NavigationContainerComponent);
